import { render, staticRenderFns } from "./TypeSelection.vue?vue&type=template&id=33b29e5a&"
import script from "./TypeSelection.vue?vue&type=script&lang=js&"
export * from "./TypeSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports